// ── soundGate — когда звукам интерфейса можно звучать ───────────────────────────
// Общее для звуков тем («Аркада» — arcadeJuice.js, «Колода» — tableSounds.js): настройка
// «Звуки интерфейса» (ac_ui_sounds) и тишина, пока играет аудио или видео или текст
// читается вслух — урок важнее щелчков. Здесь же — что считается нажатием и где касание
// мимо кнопок — часть работы (поле ввода, холст игры), а не стук по столу.

export const SOUND_KEY = 'ac_ui_sounds';
export const uiSoundsEnabled = () => { try { return localStorage.getItem(SOUND_KEY) !== '0'; } catch { return true; } };

export function mediaBusy() {
  try {
    if (window.speechSynthesis?.speaking) return true;
    return Array.from(document.querySelectorAll('audio,video')).some((m) => !m.paused && !m.ended);
  } catch { return false; }
}

// Нажатие: кнопки, ссылки, строки списков, переключатели.
export const PRESSABLE = 'button, a[href], [role="button"], [role="menuitem"], [role="tab"], [role="option"], label, select, input[type="checkbox"], input[type="radio"], .ac-row-click';
// Касание — часть работы: не отвечаем звуком стола.
export const QUIET = 'input, textarea, select, [contenteditable="true"], canvas, [data-no-juice]';
